import { Routes, Route, useNavigate, useParams, useLocation } from "react-router-dom";
import './bands.scss';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Band from "../../components/band/band";
import Spinner from './../../assets/images/spinner.svg'
import { HashLink as Link } from 'react-router-hash-link';
import RigAkustikFlyer from "../../components/flyer/RigAkustikFlyer";
import { STRAPI_URL } from "../../config/env";
import { getLargestImageUrl } from "../../utils/image";

/**
 * Timeout (in Millisekunden), nachdem ein Rerender erfolgt sein sollte.
 */
const RENDER_TIMEOUT = 200

export default function Bands({ history, akustik, homepageData = {} }) {
  const location = useLocation()
  const path = history ? '/history' : akustik ? '/akustik' : '/bands';
  const pathParams = useParams()
  const selectedBandParam = pathParams['*']
  const navigate = useNavigate()
  const showNewBands = homepageData.showNewBands
  const filtersReady = typeof showNewBands !== 'undefined' || Object.keys(homepageData).length > 0
  const akustikFlyerAssets = homepageData.AkustikFlyerOnHomepage?.data ?? []

  const akustikFlyerFront = getLargestImageUrl(akustikFlyerAssets[0])
  const akustikFlyerBack = getLargestImageUrl(akustikFlyerAssets[1]) ?? akustikFlyerFront

  const [bandData, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!filtersReady) {
      setLoading(true)
      return
    }

    const fetchData = async () => {
      setLoading(true);
      try {
        const { data: response } = await axios.get(`${STRAPI_URL}/api/bands-rig?populate=*`);
        const bandData = response.data
          .filter(filterBandsBy(path))
          .filter(akustik ? () => true : filterBandsByShowNewBands(showNewBands))
        bandData.sort(compareBands)
        setData(bandData);
      } catch (error) {
        console.error(error.message);
      }
      setLoading(false);
    }
    fetchData();
  }, [setData, path, showNewBands, filtersReady, akustik]);

  // Navigiere automatisch zur ersten Band, wenn keine Band ausgewählt ist
  useEffect(() => {
    let scrollTimeout;
    if (!selectedBandParam && bandData.length > 0) {
      navigate(`${path}${bandData[0].attributes.rigUrl}`)
      // Warte Rerender ab un scrolle dann zur Bandbox (funktioniert nicht über `navigate` Funktion)
      scrollTimeout = setTimeout(() => {
        const bandBox = document.getElementById('bandbox')
        if (bandBox) {
          bandBox.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, RENDER_TIMEOUT);
    }
    return () => clearTimeout(scrollTimeout)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bandData])

  const bandExists = bandData.find(x => path + x.attributes.rigUrl === location.pathname)
  const navigationClass = akustik ? 'navigation bigHeader' : 'navigation'
  return (
    <div className="bandsSection">
      <div className={navigationClass}>
        <ul className="cloud" role="navigation" aria-label="Bandcloud">
          {!loading && filtersReady && bandData.map((bandRaw, i, row) => {
            const band = bandRaw.attributes
            const bandURL = path + band.rigUrl + '#bandbox';
            if ((!history && band.imAktuellenLinup) || (history && !band.imAktuellenLinup) || akustik) {
              if (i + 1 === row.length) {
                return (<li key={i}><Link data-weight={band.fontsize} to={bandURL}>{band.name}</Link></li>)
              }
              return (<li key={i}><Link data-weight={band.fontsize} to={bandURL}>{band.name} - </Link></li>)
            }
            return null
          })}
        </ul>
      </div>
      <div className="infos">
        {akustik && <RigAkustikFlyer className="flyerAkustik" src={akustikFlyerFront} srcHover={akustikFlyerBack} />}
        {(loading || !filtersReady) && <div className='loading'><img src={Spinner} alt="loading animation" /></div>}
      </div>
      <div id='bandbox'></div>
      <Routes>
        {!loading && filtersReady && bandExists && <Route path=":id" element={<Band path={path} bandData={bandData} />} />}
      </Routes>
    </div>
  )
}

function compareBands(a, b) {
  if (a.attributes.sort < b.attributes.sort) {
    return -1;
  }
  if (a.attributes.sort > b.attributes.sort) {
    return 1;
  }
  return 0;
}

function filterBandsBy(path) {
  const year = (new Date()).getFullYear()
  return function (band) {
    if (path === '/history') {
      return !band.attributes.imAktuellenLinup
    } else if (path === '/akustik') {
      const teilgenommen = band.attributes.teilgenommen ?? []
      return teilgenommen.find(x => {
        return x.teilgenommen === `AKKUSTIK${year}`
      })
    } else {
      return band.attributes.imAktuellenLinup
    }
  }
}

function filterBandsByShowNewBands(showNewBands) {
  return function (band) {
    const hideIfShowNewBandsFalse = band.attributes?.hideIfShowNewBandsFalse === true

    if (showNewBands === true) {
      return hideIfShowNewBandsFalse
    }

    if (showNewBands === false) {
      return !hideIfShowNewBandsFalse
    }

    return true
  }
}
